<template>
  <ValidationObserver v-slot="{ handleSubmit, invalid ,reset}" ref="observer">
    <artisio-modal size="sm" :visible="modal.show" :data="model"
                   :title="model.uuid ? $t(`Update Audience`) : $t(`Create New Audience`)"
                   @show="onShow" @hidden="onHidden" @ok.prevent="handleSubmit(onSubmit)"
                   :show-confirmation="showConfirmation" :ok-title="$t('Submit')" :is-loading="loading"
                   :content-in-form="false" scrollable>
      <div class="row">
        <div class="col-md-12">
          <input-widget :model="model" attribute="name"/>
        </div>
        <div class="col-md-12">
          <input-widget :model="model" attribute="subject"/>
        </div>
        <div class="col-md-12">
          <input-widget :model="model" attribute="description" type="textarea"/>
        </div>
      </div>
    </artisio-modal>
  </ValidationObserver>
</template>

<script>
  import InputWidget from "@/core/components/input-widget/InputWidget";
  import AudienceModel from "./Audience.model";
  import {createNamespacedHelpers} from "vuex";
  import ArtisioModal from "@/core/components/artisio-modal/ArtisioModal";
  import {SOURCE_AUDIENCES_LIST} from "@/modules/constants";
  import MarketingService from "@/modules/marketing/MarketingService";

  const {mapState, mapActions} = createNamespacedHelpers('marketing/audience');

  export default {
    name: "AudienceModal",
    components: {
      InputWidget, ArtisioModal
    },
    data() {
      return {
        loading: false,
        showConfirmation: true,
        model: new AudienceModel(),
      }
    },
    computed: {
      ...mapState({
        modal: state => state.audienceModal,
        editObject: state => state.audienceModal.object
      }),
    },
    watch: {
      editObject() {
        if (this.editObject && this.editObject.uuid) {
          this.model = new AudienceModel(this.editObject);
        }
      },
    },
    methods: {
      ...mapActions(['hideAudienceModal', 'updateAudience', 'getTableData']),
      onShow() {
        this.showConfirmation = true
      },
      onHidden() {
        this.model = new AudienceModel();
        this.hideAudienceModal();
      },
      async onSubmit() {
        let response;
        this.loading = true;

        if (!this.model.uuid) {
          response = await MarketingService.createAudience(this.model);
        } else {
          response = await this.updateAudience(this.model);
        }

        this.loading = false;

        if (response.success) {
          this.showConfirmation = false;
          this.hideAudienceModal();

          if (!this.model.uuid) {
            this.$toast('success', this.$t('Audience was successfully created'));
            if (this.modal.source === SOURCE_AUDIENCES_LIST) {
              this.getTableData()
            }
          } else {
            this.$toast('success', this.$t('Audience was successfully updated'));
          }
        } else {
          if (response.toastError) {
            this.$errorDialog(response.toastError);
          } else {
            if (response.body.non_field_errors) {
              this.$errorDialog(response.body.non_field_errors[0])
            } else {
              this.model.setMultipleErrors(response.body);
            }
          }
        }
      },
    }
  }
</script>

<style scoped>

</style>
